/* Nordic Sheep AT – "Mehr kaufen, mehr sparen" (Horizon) · v2.6 2026-09-23 (de-AT)
   Staffel (kumulativ, zählt ALLE Produkte außer der Geschenk-Bürste):
   2 = gratis Bürste · 3 = + Gratisversand · 4 = + 10 % Extra-Rabatt.
   Die Rabatte sind automatische Shopify-Rabatte; dieses Skript legt die gratis Bürste in den Warenkorb
   (und entfernt sie wieder) und hält die Staffel-Boxen (Produktseite + Warenkorb) aktuell.
   v2: Das Geschenk wird verarbeitet, BEVOR Horizon die Antwort erhält, und die Sections in der Antwort werden
   durch frisches HTML ersetzt → Drawer/Zeilennummern laufen nie auseinander ("Parameter line is invalid"-Fix).
   v2.1: refreshUI schickt frisches Section-HTML mit (leerer Drawer → gefüllter Drawer funktioniert).
   v2.2: Event-Cart via CartLinesUpdateEvent.createCartFromAjaxResponse (standard-events erwartet cart.lines).
   v2.3: 10 % → 25 %.
   v2.4: Staffel zurück auf 10 % (die -25 % gelten nur für die Produktpreise/Compare-at).
   v2.5: "Geschenk entfernt" merkt sich die Produktanzahl zu diesem Zeitpunkt und gilt nur, solange keine
         weiteren Produkte hinzukommen (vorher: Rest der Sitzung → Bürste kam nie wieder).
   v2.6 (AT): BRUSH_VARIANT ist ein Platzhalter (0), bis der Produktimport die echte Varianten-ID einsetzt.
         Solange BRUSH_VARIANT 0 ist, wird kein Geschenk hinzugefügt/entfernt – die Staffel-Anzeige läuft trotzdem. */
const BRUSH_VARIANT = 58502593970559; // Varianten-ID der Lammfellbürste (nco1308) auf nordicsheep.at
const GIFT_MIN = 2;
/* v2.7 (22-10-2026): børsten udsolgt/kladde → ingen gave; trappen bliver 2 = gratis verzending, 4 = 10%. */
const GIFT_ON = window.nsGiftOn !== false;
const KEY_DISMISS = 'nsGiftDismissedAt';
const H = { 'Content-Type': 'application/json', Accept: 'application/json', 'X-NS-Gift': '1' };
const origFetch = window.fetch.bind(window);

let lastCart = null;
let running = null;
let again = false;

const isGift = (it) => !!BRUSH_VARIANT && it.variant_id === BRUSH_VARIANT && it.properties && it.properties._free_gift;
const qualifying = (cart) => cart.items.filter((it) => !isGift(it)).reduce((s, it) => s + it.quantity, 0);
const isDismissed = (q) => { try { const v = sessionStorage.getItem(KEY_DISMISS); return v !== null && q <= Number(v); } catch (e) { return false; } };
const setDismissed = (q) => { try { sessionStorage.setItem(KEY_DISMISS, String(q)); } catch (e) {} };
const clearDismissed = () => { try { sessionStorage.removeItem(KEY_DISMISS); sessionStorage.removeItem('nsGiftDismissed'); } catch (e) {} };

async function getCart() {
  const r = await origFetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
  lastCart = await r.json();
  return lastCart;
}
function post(url, body) {
  return origFetch(url, { method: 'POST', headers: H, credentials: 'same-origin', body: JSON.stringify(body) });
}

async function reconcileOnce() {
  const cart = await getCart();
  if (!BRUSH_VARIANT) return false; // Platzhalter nicht gesetzt → kein Geschenk-Handling (Staffel-Anzeige läuft weiter)
  const q = qualifying(cart);
  const gifts = cart.items.filter(isGift);
  let changed = false;
  if (!GIFT_ON) {
    for (const g of gifts) { await post('/cart/change.js', { id: g.key, quantity: 0 }); changed = true; }
    if (changed) await getCart();
    return changed;
  }
  if (q < GIFT_MIN) clearDismissed();
  if (q >= GIFT_MIN && !isDismissed(q)) {
    if (!gifts.length) {
      await post('/cart/add.js', { items: [{ id: BRUSH_VARIANT, quantity: 1, properties: { _free_gift: '1' } }] });
      changed = true;
    } else {
      for (const g of gifts.slice(1)) { await post('/cart/change.js', { id: g.key, quantity: 0 }); changed = true; }
      if (gifts[0].quantity !== 1) { await post('/cart/change.js', { id: gifts[0].key, quantity: 1 }); changed = true; }
    }
  } else if (q < GIFT_MIN && gifts.length) {
    for (const g of gifts) await post('/cart/change.js', { id: g.key, quantity: 0 });
    changed = true;
  }
  if (changed) await getCart();
  return changed;
}

function reconcile() {
  if (running) { again = true; return running; }
  running = (async () => {
    let changed = false;
    do {
      again = false;
      try { changed = (await reconcileOnce()) || changed; } catch (e) { console.warn('[ns-gift]', e); }
    } while (again);
    return changed;
  })().then((changed) => { running = null; updateLadder(); return changed; });
  return running;
}

function cartSectionIds() {
  return [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);
}
async function freshSections(ids) {
  if (!ids.length) return null;
  const r = await origFetch(`${location.pathname}?sections=${ids.join(',')}`, { credentials: 'same-origin' });
  return r.json();
}

/* Horizon neu rendern lassen (Drawer + Warenkorb-Icon), ohne den Drawer automatisch zu öffnen. */
async function refreshUI() {
  await getCart();
  const count = lastCart.item_count;
  try {
    const sections = await freshSections(cartSectionIds());
    const { CartLinesUpdateEvent } = await import('@shopify/events');
    const cart = CartLinesUpdateEvent.createCartFromAjaxResponse(Object.assign({}, lastCart));
    const promise = Promise.resolve({ cart, detail: { sections: sections || undefined, items: lastCart.items, itemCount: count, source: 'ns-gift', didError: false } });
    document.dispatchEvent(new CartLinesUpdateEvent({ action: 'update', context: 'cart', lines: [], promise }));
    await promise;
    setTimeout(updateLadder, 400);
  } catch (e) {
    console.warn('[ns-gift] refreshUI', e);
    if (location.pathname.indexOf('/cart') === 0) location.reload();
  }
}

async function openDrawer() {
  await refreshUI();
  const d = document.getElementById('cart-drawer');
  if (d && typeof d.open === 'function' && location.pathname.indexOf('/cart') !== 0) {
    setTimeout(() => d.open(), 250);
  } else {
    location.href = '/cart';
  }
}

/* Manuelles Entfernen des Geschenks respektieren – aber nur, solange keine Produkte hinzukommen. */
function noteDismiss(init) {
  if (!init || !init.body || !lastCart) return;
  let b = init.body;
  try { b = typeof b === 'string' ? JSON.parse(b) : null; } catch (e) { b = null; }
  if (!b || Number(b.quantity) !== 0) return;
  let item = null;
  if (b.id) item = lastCart.items.find((it) => it.key === String(b.id) || it.variant_id === Number(b.id));
  else if (b.line) item = lastCart.items[Number(b.line) - 1];
  if (item && isGift(item)) setDismissed(qualifying(lastCart));
}

window.fetch = async function (input, init) {
  const url = typeof input === 'string' ? input : (input && input.url) || '';
  const hdrs = init && init.headers;
  const ours = hdrs && (hdrs['X-NS-Gift'] || (typeof hdrs.get === 'function' && hdrs.get('X-NS-Gift')));
  const isCartMutation = !ours && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
  if (!isCartMutation) return origFetch(input, init);
  if (/\/cart\/change/.test(url)) noteDismiss(init);

  const res = await origFetch(input, init);
  if (!res.ok) return res;
  let changed = false;
  try { changed = await reconcile(); } catch (e) {}
  if (!changed) return res;

  // Geschenk wurde hinzugefügt/entfernt: Horizon eine Antwort mit frischen Sections + Cart-Daten geben.
  try {
    const data = await res.clone().json();
    const ids = data && data.sections ? Object.keys(data.sections) : [];
    if (ids.length) data.sections = Object.assign({}, data.sections, await freshSections(ids));
    if (lastCart && Array.isArray(data.items) && 'item_count' in data) {
      const sections = data.sections;
      Object.assign(data, lastCart);
      if (sections) data.sections = sections;
    }
    const headers = new Headers(res.headers);
    headers.delete('content-length');
    return new Response(JSON.stringify(data), { status: res.status, statusText: res.statusText, headers });
  } catch (e) {
    setTimeout(refreshUI, 0);
    return res;
  }
};

/* Staffel-Boxen */
const NEXT = { 2: 'bis zur gratis Lammfellbürste', 3: 'bis zum Gratisversand', 4: 'bis zu 10 % Extra-Rabatt' };
function cartMessage(q) {
  if (!GIFT_ON) {
    if (q <= 0) return '🛍️ Kaufe 2 Produkte und erhalte Gratisversand';
    if (q === 1) return 'Noch 1 Produkt bis zum 🚚 Gratisversand';
    if (q === 2) return '🚚 Gratisversand gesichert! Noch 2 Produkte bis zu 💰 10 % Extra-Rabatt';
    if (q === 3) return '🚚 Gratisversand gesichert! Noch 1 Produkt bis zu 💰 10 % Extra-Rabatt';
    return '🎉 Alle Vorteile aktiv: Gratisversand und 10 % Rabatt';
  }
  if (q <= 0) return '🛍️ Kaufe 2 Produkte und erhalte eine gratis Lammfellbürste';
  if (q === 1) return 'Noch 1 Produkt bis zur 🎁 gratis Lammfellbürste';
  if (q === 2) return '🎁 Gratis Bürste gesichert! Noch 1 Produkt bis zum 🚚 Gratisversand';
  if (q === 3) return '🚚 Gratisversand gesichert! Noch 1 Produkt bis zu 💰 10 % Extra-Rabatt';
  return '🎉 Alle Vorteile aktiv: gratis Bürste, Gratisversand und 10 % Rabatt';
}
function updateLadder() {
  if (!lastCart) return;
  const q = qualifying(lastCart);
  document.querySelectorAll('[data-ns-ladder]').forEach((box) => {
    box.querySelectorAll('[data-step]').forEach((li) => li.classList.toggle('is-done', q >= Number(li.dataset.step)));
    const status = box.querySelector('[data-ladder-status]');
    if (!status) return;
    if (q === 0) { status.hidden = true; return; }
    status.hidden = false;
    if (q >= 4) { status.textContent = '🎉 Alle Vorteile sind in deinem Warenkorb aktiv!'; return; }
    const next = q < 2 ? 2 : (GIFT_ON ? q + 1 : 4);
    const NX = GIFT_ON ? NEXT : { 2: NEXT[3], 4: NEXT[4] };
    status.textContent = `Du hast ${q} ${q === 1 ? 'Produkt' : 'Produkte'} im Warenkorb – noch ${next - q} ${NX[next]}.`;
  });
  document.querySelectorAll('[data-ns-cartladder]').forEach((box) => {
    const msg = box.querySelector('[data-cl-msg]');
    if (msg) msg.textContent = cartMessage(q);
    const fill = box.querySelector('[data-cl-fill]');
    if (fill) fill.style.width = `${(Math.min(q, 4) / 4) * 100}%`;
    box.querySelectorAll('[data-step]').forEach((li) => li.classList.toggle('is-done', q >= Number(li.dataset.step)));
  });
}

/* NC 30-10-2026: trappens procent foelger window.nsLadderPct (5 i Black November 30.10-30.11, ellers 10). */
function nsFixPct() {
  const lp = Number(window.nsLadderPct) || 10;
  if (lp === 10) return;
  document.querySelectorAll('[data-ns-ladder],[data-ns-cartladder]').forEach((b) => {
    const w = document.createTreeWalker(b, NodeFilter.SHOW_TEXT); let n;
    while ((n = w.nextNode())) { if (/(^|[^0-9])10(\s?)%/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/(^|[^0-9])10(\s?)%/g, '$1' + lp + '$2%'); }
  });
}
{ const nsUL0 = updateLadder; updateLadder = function () { nsUL0(); nsFixPct(); }; }
window.nsGift = { reconcile, updateLadder, refreshUI, openDrawer };
reconcile().then((changed) => { if (changed) refreshUI(); });
